
import { BASE_URL } from '@/common/constant';
import { Vue, Component, Watch, Ref } from 'vue-property-decorator';
import lazyInject from '@/di';
import ShopService from '@/services/shop.service';
import SPUService from '@/services/spu.service';
import BatchDeletePois from '../shop/components/BatchDeletePois.vue';
import { SPUFieldFactory } from '@/models/spuFieldFactory';
import {
  IResPlatformSPU,
  ISPUCategory,
  ISPUField,
  ISPUProduct,
} from '@/common/interface/spu';

import { PlatformSPU } from '@/models/spu.model';
import { ESPUField, ENProductSource } from '@/common/enum/spu';
import SPUEditor from '@/components/spu/SPUEditor.vue';
import _ from 'lodash';
import { KeyObject } from '@/common/interface';
import PermissionService, { AuthEnum } from '@/services/permission.service';
import ApplicableLookShops from '@/components/spu/ApplicableLookShops.vue';
import TimedPriceChangeModal from './components/TimedPriceChangeModal.vue';

@Component({
  components: {
    BatchDeletePois,
    SPUEditor,
    ApplicableLookShops,
    TimedPriceChangeModal,
  },
})
export default class SpuPlatform extends Vue {
  AuthEnum = AuthEnum;

  BASE_URL = BASE_URL;

  title: any = '新增平台标准商品';

  spuVideoPermmison: KeyObject<boolean> = {};

  form: {
    name: string;
    spuId: string;
    categoryId?: string | number;
    selfOperated: string;
    online: string | number;
  } = {
    name: '',
    spuId: '',
    categoryId: '',
    selfOperated: '-1',
    online: '',
  };

  listData: IResPlatformSPU[] = [];

  ENProductSource = ENProductSource;

  pagination = {
    total: 0,
    pageSize: 20,
    current: 1,
    onChange: this.paginationChange,
  };

  selfOperatedList: any[] = [
    {
      value: '-1',
      label: '全部',
    },
    {
      value: '1',
      label: '是',
    },
    {
      value: '0',
      label: '否',
    },
  ];

  columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: 80,
      align: 'center',
    },
    {
      title: '商品名称',
      dataIndex: 'name',
      key: 'name',
      width: 240,
      align: 'center',
    },
    {
      title: '商品类目',
      dataIndex: 'scategory',
      key: 'scategory',
      scopedSlots: { customRender: 'scategory' },
      width: 80,
      align: 'center',
    },
    {
      title: '商品照片',
      dataIndex: 'headlineImage',
      key: 'headlineImage',
      scopedSlots: { customRender: 'headlineImage' },
      width: 80,
      align: 'center',
    },
    {
      title: '门市价',
      dataIndex: 'originalPriceCent',
      scopedSlots: { customRender: 'originalPriceCent' },
      width: 100,
      align: 'center',
    },
    {
      title: '黑卡价',
      dataIndex: 'vipPriceCent',
      key: 'vipPriceCent',
      scopedSlots: { customRender: 'vipPriceCent' },
      width: 100,
      align: 'center',
    },
    {
      title: '采购价',
      dataIndex: 'purchasePrice',
      key: 'purchasePrice',
      scopedSlots: { customRender: 'purchasePrice' },
      width: 100,
      align: 'center',
    },
    {
      title: '是否甄选',
      dataIndex: 'isPreferred',
      key: 'isPreferred',
      scopedSlots: { customRender: 'isPreferred' },
      width: 100,
      align: 'center',
    },
    {
      title: '服务详情',
      dataIndex: 'introduction',
      key: 'introduction',
      scopedSlots: { customRender: 'introduction' },
      width: 160,
      align: 'center',
    },
    {
      title: '商品相册',
      dataIndex: 'images',
      key: 'images',
      scopedSlots: { customRender: 'images' },
      width: 120,
      align: 'center',
    },
    {
      title: '适用门店',
      dataIndex: 'tempSpuShopIds',
      key: 'tempSpuShopIds',
      scopedSlots: { customRender: 'tempSpuShopIds' },
      width: 120,
      align: 'center',
    },
    {
      title: '创建时间',
      dataIndex: 'createTime',
      key: 'createTime',
      scopedSlots: { customRender: 'createTime' },
      width: 180,
      align: 'center',
    },
    {
      title: '最近修改时间',
      dataIndex: 'last_update_time',
      key: 'last_update_time',
      scopedSlots: { customRender: 'last_update_time' },
      width: 180,
      align: 'center',
    },
    {
      title: '是否自营品',
      dataIndex: 'selfOperated',
      key: 'selfOperated',
      width: 120,
      align: 'center',
      customRender: (text: number) => {
        return text === 1 ? '是' : '否';
      },
    },
    {
      title: '状态',
      dataIndex: 'online',
      key: 'online',
      width: 120,
      align: 'center',
      customRender: (text: number) => {
        return text === 1 ? '已上线' : '已下线';
      },
    },
    {
      title: '操作',
      dataIndex: 'actions',
      fixed: 'right',
      key: 'actions',
      scopedSlots: { customRender: 'actions' },
      width: 200,
      align: 'center',
    },
  ];

  lookShops = '';

  /** 分类数据 */
  secondCategoryList: ISPUCategory[] = [];

  spuConfig: ISPUField[] = [];

  initSpuFields: ISPUField[] = SPUFieldFactory.init({
    spuType: 'platformSpu',
    vipPriceValidator: this.vipPriceValidator,
    originalPriceValidator: this.originalPriceValidator,
    newUserPriceValidator: this.newUserPriceValidator,
    purchasePriceValidator: this.purchasePriceValidator,
  });

  editingSpu: PlatformSPU = new PlatformSPU();

  spuForm: { [key: string]: any } = {};

  @Ref()
  batchDeletePois!: BatchDeletePois;

  @Ref()
  spuEditor!: SPUEditor;

  @Ref()
  applicableLookShops!: ApplicableLookShops;

  @Ref('timedPriceChangeModal')
  timedPriceChangeModal!: TimedPriceChangeModal;

  @lazyInject(ShopService)
  shopService!: ShopService;

  @lazyInject(PermissionService)
  protected permissionService!: PermissionService;

  @lazyInject(SPUService)
  protected spuService!: SPUService;

  async showAllShops(tempSpuShopIds: string) {
    this.lookShops = tempSpuShopIds;
    await this.applicableLookShops.open(tempSpuShopIds);
  }

  /** 列表查询 */
  @Watch('$route')
  async handleSearch() {
    const { name, spuId, categoryId, selfOperated, online } = this.$route.query;
    const { pageSize, current } = this.pagination;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const param: any = {
      pageSize,
      page: current,
    };

    if (name) {
      this.form.name = name as string;
      param.name = name;
    }
    if (spuId) {
      this.form.spuId = spuId as string;
      param.spuId = spuId;
    }
    if (categoryId) {
      this.form.categoryId = +categoryId;
      param.categoryId = categoryId;
    }
    if (selfOperated) {
      this.form.selfOperated = selfOperated as string;
      param.selfOperated = selfOperated;
    }
    if (online !== '' && online !== undefined) {
      this.form.online = +online;
      param.online = online;
    }
    await this.all(param);
  }

  getApplicableShops(poiids: string, length: number) {
    const poiList = !poiids ? [] : poiids.split(',');
    if (!poiList.length) {
      return [];
    }
    if (poiList.length < length) {
      return poiList;
    }
    return poiList.splice(0, length);
  }

  async getCategory() {
    const data = await this.spuService.spuCategories({
      aggregation: true,
      loadingEl: this.$el,
    });
    this.secondCategoryList = data.reduce((prev, cur) => {
      return prev.concat(cur.children || []);
    }, [] as ISPUCategory[]);
  }

  paginationChange(current: number) {
    this.pagination.current = current;
    const { name, spuId, categoryId } = this.$route.query;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const query: any = {
      page: current,
    };
    if (name) {
      query.name = name;
    }

    if (spuId) {
      query.spuId = spuId;
    }
    if (categoryId) {
      query.categoryId = categoryId;
    }

    this.$router.push({
      query,
    });
  }

  callback(value: any) {
    this.form.online = value;
    this.search();
  }

  /** 点击查询 */
  search() {
    this.pagination = {
      total: 0,
      pageSize: 20,
      current: 1,
      onChange: this.paginationChange,
    };
    const { name, spuId, categoryId, selfOperated, online } = this.form;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const query: any = {
      page: `${this.pagination.current}`,
    };
    if (name) {
      query.name = name;
    }

    if (spuId) {
      query.spuId = spuId;
    }

    if (categoryId) {
      query.categoryId = categoryId;
    }
    if (selfOperated !== '-1') {
      query.selfOperated = selfOperated;
    }
    if (online !== '') {
      query.online = online;
    }
    query.timestamp = Math.round(Date.now() / 1000);
    this.$router.push({
      query,
    });
  }

  /** 页面刷新 */
  refresh() {
    this.pagination = {
      total: 0,
      pageSize: 20,
      current: 1,
      onChange: this.paginationChange,
    };
    this.form = {
      name: '',
      spuId: '',
      categoryId: '',
      selfOperated: '-1',
      online: '',
    };
    this.$router.push({
      query: {},
    });
  }

  async all(params: {
    pageSize: number;
    page: number;
    name?: string;
    spuId?: string;
    categoryId?: number;
    selfOperated?: string;
    online?: string;
  }) {
    const res = await this.spuService.platformSpuList(params, this.$el);
    if (res) {
      this.listData = res.list;
      this.pagination = {
        total: res.total,
        current: res.page,
        pageSize: Number(res.pageSize),
        onChange: this.paginationChange,
      };
    }
  }

  async changeOnlineStatus(spuId: string, isOnline: boolean) {
    const res = await this.spuService.platformSpuOnlineStatusChange(
      spuId,
      !isOnline,
      this.$el,
    );
    if (res) {
      this.$message.success(res);
      setTimeout(() => {
        this.handleSearch();
      }, 500);
    }
  }

  async deleteSpu(spu: IResPlatformSPU) {
    const res = await this.spuService.platformSpuDelete(`${spu.id}`, this.$el);
    if (res) {
      this.$message.success('删除成功');
      setTimeout(() => {
        this.handleSearch();
      }, 500);
    }
  }

  openBatchDeletePoisModal() {
    this.batchDeletePois.visible = true;
  }

  vipPriceValidator(
    rule: { [key: string]: string | (() => boolean) },
    value: string,
  ) {
    const { originalPriceCent, products } = this.spuForm;

    if (products.length) {
      return +value < +this.spuForm.comboTotalPrice.originalPriceCent;
    } else {
      if (+value > 0 && (!originalPriceCent || isNaN(+originalPriceCent))) {
        return true;
      }
      return +value < +originalPriceCent;
    }
  }

  purchasePriceValidator(
    rule: { [key: string]: string | (() => boolean) },
    value: string,
  ) {
    const { vipPriceCent } = this.spuForm;
    if (+value > 0 && (!vipPriceCent || isNaN(+vipPriceCent))) {
      return true;
    }
    return +value < +vipPriceCent;
  }

  newUserPriceValidator(
    rule: { [key: string]: string | (() => boolean) },
    value: string,
  ) {
    const { vipPriceCent } = this.spuForm;
    if (!vipPriceCent || isNaN(+vipPriceCent)) {
      return true;
    }
    return +value < +vipPriceCent;
  }

  originalPriceValidator(
    rule: { [key: string]: string | (() => boolean) },
    value: string,
  ) {
    const { products } = this.spuForm;
    if (products.length) {
      return +this.spuForm.comboTotalPrice.originalPriceCent > 0;
    } else {
      return +value > 0;
    }
  }

  /** 新增商品 */
  add() {
    this.editingSpu = new PlatformSPU();
    this.initSpuForm(this.editingSpu);
    this.title = '新增平台标准商品';
  }

  /** 修改商品 */
  async edit(id: number) {
    this.title = '修改平台标准商品';
    const data = (await this.spuService.platformSpuDetail(`${id}`)) as any;
    const res = (await this.spuService.getAutoUpShelfTime(`${id}`)) as any;
    if (res) {
      const _obj: any = {
        ...data,
        ...res,
      };
      // console.log(_obj);
      this.editingSpu = PlatformSPU.from(_obj);
      this.editingSpu.noticeInfos = this.editingSpu.noticeInfos.map(
        (item: any) => ({
          ...item,
          remarks: Array.isArray(item.remarks)
            ? item.remarks.join('\n')
            : item.remarks,
        }),
      );
      this.initSpuForm(this.editingSpu);
    }
  }

  changePic(id: any) {
    this.timedPriceChangeModal.init(id);
  }

  async copy(id: number) {
    this.title = '复制平台标准商品';
    const data = (await this.spuService.platformSpuDetail(`${id}`)) as any;
    const res = (await this.spuService.getAutoUpShelfTime(`${id}`)) as any;
    if (res) {
      const _obj: any = {
        ...data,
        ...res,
      };
      // console.log(_obj);
      this.editingSpu = PlatformSPU.from(_obj);
      const _spu: any = this.editingSpu;
      _spu.id = 0;
      this.initSpuForm(_spu);
    }
  }

  initSpuForm(editingSpu: PlatformSPU) {
    const form: { [key: string]: any } = {};
    const times =
      editingSpu.effectiveTimes > 0 ? editingSpu.effectiveTimes * 100 : 100;

    for (const [key, value] of Object.entries(editingSpu)) {
      switch (key) {
        case ESPUField.EFFECTIVE_TIMES: {
          if (Number(value) > 1) {
            form.isCombo = true;
          } else {
            form.isCombo = false;
          }
          form[key] = value;
          break;
        }
        case ESPUField.ORIGINAL_PRICE_CENT: {
          form[key] = value !== 0 ? (value / times).toFixed(2) : '';
          break;
        }
        case ESPUField.VIP_PRICE_CENT: {
          form[key] = value !== 0 ? (value / times).toFixed(2) : '';
          break;
        }
        case ESPUField.NEW_USER_PRICE_CENT: {
          form.hasNewUserPrice = value > 0;
          form[key] = value !== 0 ? (value / times).toFixed(2) : '';
          break;
        }

        case ESPUField.PURCHASE_PRICE: {
          form[key] = value !== 0 ? (value / times).toFixed(2) : '';
          break;
        }

        default: {
          form[key] = value;
          break;
        }
      }
    }
    // console.log(editingSpu);
    // 自动上架
    if (editingSpu.autoUpShelfTime) {
      form.isAutoOnShelf = true;
    }
    // 自动下架
    if (editingSpu.autoOffShelfTime) {
      form.isAutoOffShelf = true;
    }

    form.comboTotalPrice = {
      originalPriceCent: editingSpu.originalPriceCent,
      vipPriceCent: editingSpu.vipPriceCent,
      newUserPriceCent: editingSpu.newUserPriceCent,
    };

    this.handleUpdate(form, true);
  }

  initSpuConfig() {
    const spu = { ...this.spuForm };
    const detail = _.cloneDeep(this.initSpuFields);
    const isComboIndex = detail.findIndex(
      (item) => item.label === ESPUField.IS_COMBO,
    );
    const idIdx = detail.findIndex((item) => item.label === ESPUField.ID);
    const producttypeIdx = detail.findIndex(
      (item) => item.label === ESPUField.PRODUCT_TYPE,
    );

    const autoOffShelfTimeIdx = detail.findIndex(
      (item) => item.label === ESPUField.AUTO_OFF_SHELF_TIME,
    );
    const autoUpShelfTimeIdx = detail.findIndex(
      (item) => item.label === ESPUField.AUTO_ON_SHELF_TIME,
    );
    const originalPriceIdx = detail.findIndex(
      (item) => item.label === ESPUField.ORIGINAL_PRICE_CENT,
    );
    const vipPriceIdx = detail.findIndex(
      (item) => item.label === ESPUField.VIP_PRICE_CENT,
    );
    const newUserPriceIdx = detail.findIndex(
      (item) => item.label === ESPUField.NEW_USER_PRICE_CENT,
    );
    const comboTotalPriceIdx = detail.findIndex(
      (item) => item.label === ESPUField.COMBO_TOTAL_PRICE,
    );
    const effectiveTimesIdx = detail.findIndex(
      (item) => item.label === ESPUField.EFFECTIVE_TIMES,
    );
    const videosIdx = detail.findIndex(
      (item) => item.label === ESPUField.VIDEOS,
    );

    const stockCountIndex = detail.findIndex(
      (item) => item.label === ESPUField.STOCK_COUNT,
    );
    const purchasePriceIndex = detail.findIndex(
      (item) => item.label === ESPUField.PURCHASE_PRICE,
    );
    const commissionRatioIndex = detail.findIndex(
      (item) => item.label === ESPUField.COMMISSION_RATIO,
    );

    if (spu.id === 0) {
      // 新增商品时允许更换是否套餐
      detail[isComboIndex].readonly = false;
      detail[idIdx].isHidden = true;
      detail[producttypeIdx].readonly = false;
    } else {
      // 编辑商品不允许更改是否套餐的选项
      detail[isComboIndex].readonly = true;
      detail[idIdx].isHidden = false;
      detail[producttypeIdx].readonly = true;
    }

    if (spu.selfOperated === 1) {
      detail[purchasePriceIndex].isHidden = false;
      detail[commissionRatioIndex].isHidden = true;
    } else {
      detail[purchasePriceIndex].isHidden = true;
      detail[commissionRatioIndex].isHidden = false;
    }

    if (spu.isCombo === true) {
      detail[effectiveTimesIdx].isHidden = false;
      detail[comboTotalPriceIdx].isHidden = false;
      detail[originalPriceIdx].labelName = '单次门市价(元)';
      detail[vipPriceIdx].labelName = '单次黑卡价(元)';
      detail[newUserPriceIdx].labelName = '单次特价(元)';
    } else {
      detail[effectiveTimesIdx].isHidden = true;
      detail[comboTotalPriceIdx].isHidden = true;
      detail[originalPriceIdx].labelName = '门市价(元)';
      detail[vipPriceIdx].labelName = '黑卡价(元)';
      detail[newUserPriceIdx].labelName = '特价(元)';
    }

    if (spu.multi === 1) {
      detail[stockCountIndex].isHidden = false;
    } else {
      detail[stockCountIndex].isHidden = true;
    }

    if (spu.hasNewUserPrice === true) {
      detail[newUserPriceIdx].isHidden = false;
      if (spu.selfOperated === 1) {
        this.spuForm.newUserPriceCent = spu.purchasePrice as string;
      }
    } else {
      detail[newUserPriceIdx].isHidden = true;
    }
    if (spu.isAutoOffShelf === true) {
      detail[autoOffShelfTimeIdx].isHidden = false;
      detail[autoOffShelfTimeIdx].rule = [
        { required: true, message: '自动下架时间不能为空', trigger: 'blur' },
        {
          validator: this.autoOffShelfTimeValidator,
          message: '自动下架时间至少设置在10分钟以后',
          trigger: 'blur',
        },
      ];
    } else {
      detail[autoOffShelfTimeIdx].isHidden = true;
      if (detail[autoOffShelfTimeIdx].rule) {
        delete detail[autoOffShelfTimeIdx].rule;
      }
    }

    if (
      this.spuVideoPermmison &&
      this.spuVideoPermmison[AuthEnum.标品视频管理]
    ) {
      detail[videosIdx].isHidden = false;
    } else {
      detail[videosIdx].isHidden = true;
    }

    if (spu.isAutoOnShelf === true) {
      detail[autoUpShelfTimeIdx].isHidden = false;
      detail[autoUpShelfTimeIdx].rule = [
        { required: true, message: '自动上架时间不能为空', trigger: 'blur' },
        {
          validator: this.autoOffShelfTimeValidator,
          message: '自动上架时间至少设置在10分钟以后',
          trigger: 'blur',
        },
      ];
    } else {
      detail[autoUpShelfTimeIdx].isHidden = true;
      if (detail[autoUpShelfTimeIdx].rule) {
        delete detail[autoUpShelfTimeIdx].rule;
      }
    }

    return detail;
  }
  autoOffShelfTimeValidator(
    rule: { [key: string]: string | (() => boolean) },
    value: string,
  ) {
    const duration = 60 * 10;
    const now = Math.round(Date.now() / 1000);
    const offShelfTime = Math.round(new Date(value).getTime() / 1000);
    if (offShelfTime - now < duration) {
      this.$message.error('自动下架时间至少设置在10分钟以后');
      return false;
    }
    return true;
  }
  async handleSubmit(val: { [key: string]: any }) {
    if (val.autoUpShelfTime && val.autoOffShelfTime) {
      const upShelfTime = new Date(val.autoUpShelfTime).getTime();
      const offShelfTime = new Date(val.autoOffShelfTime).getTime();
      if (upShelfTime >= offShelfTime) {
        this.$message.error('上架时间应小于下架时间');
        return;
      }
    }
    const {
      category,
      effectiveTimes,
      introduction,
      isHot,
      name,
      products,
      images,
      unavailableTime,
      id,
      shortComment,
      isDrawCommission,
      tempSpuShopPois,
      platFlag,
      videos,
      headlineImages,
      commissionRatio,
      autoUpShelfTime,
      autoOffShelfTime,
      isAutoOnShelf,
      isAutoOffShelf,
      stock,
      multi,
      isPreferred,
      noticeInfos,
      selfOperated,
      purchasePrice,
      refund_expire_conf,
      // headlineImage,
    } = val;
    const { originalPriceCent, vipPriceCent, newUserPriceCent } =
      val.comboTotalPrice;
    // console.log(noticeInfos);
    const spu: { [key: string]: any } = {
      category,
      effectiveTimes,
      name,
      unavailableTime,
      products,
      originalPriceCent,
      vipPriceCent,
      newUserPriceCent,
      isHot,
      introduction,
      images,
      autoUpShelfTime,
      autoOffShelfTime,
      stock,
      multi,
      isPreferred,
      selfOperated,
      refund_expire_conf,
      purchasePrice: Math.round(100 * purchasePrice),
      noticeInfos: noticeInfos
        ? noticeInfos.map((item: any) => ({
            ...item,
            remarks: item.remarks.split('\n'),
          }))
        : [],
    };
    if (videos.length) {
      spu.videos = videos;
    }
    // spu.headlineImage = headlineImage;
    spu.headlineImage = headlineImages.shift() || { id: 0, url: '' };
    spu.headlineOtherImage = [...headlineImages];
    spu.platformProduct = {
      commissionRatio,
      isCopyPlatformProduct: 0,
      isDrawCommission: isDrawCommission === true ? 1 : 0,
      isPlatformProduct: platFlag === 1 ? 1 : 0,
      shortComment: shortComment || '',
      tempSpuShopPois: tempSpuShopPois || '',
    };
    if (!isAutoOnShelf) {
      spu.autoUpShelfTime = null;
    }
    if (!isAutoOffShelf) {
      spu.autoOffShelfTime = null;
    }
    if (multi === 0) {
      delete spu.stock;
    }
    if (id !== 0) {
      // 编辑商品
      spu.id = id;
      const res = await this.spuService.platformSpuEdit(spu.id, spu, this.$el);
      if (!res) {
        return;
      }
      this.$message.success('修改成功');
      await this.handleSearch();
      this.spuEditor.close();
    } else {
      // 新增商品
      const res = await this.spuService.platformSpuCreate(spu, this.$el);
      if (!res) {
        return;
      }
      this.$message.success('新增成功');
      await this.handleSearch();
      this.spuEditor.close();
    }
  }

  async handleUpdate(form: { [key: string]: any }, initial?: boolean) {
    this.spuForm = { ...form };
    if (initial && initial === true) {
      // 初始化商品
      this.spuEditor.setup(this.initSpuConfig(), this.spuForm);
      return;
    }

    // 更新商品属性
    if (!this.spuForm.hasNewUserPrice) {
      this.$set(this.spuForm, ESPUField.NEW_USER_PRICE_CENT, '0.00');
    }
    if (!this.spuForm.isCombo) {
      this.$set(this.spuForm, ESPUField.EFFECTIVE_TIMES, 1);
    }
    if (this.spuForm.products && this.spuForm.products.length) {
      const priceCent = (this.spuForm.products as ISPUProduct[])
        .map(({ originalPriceCent }) => +originalPriceCent)
        .reduce((prev, cur) => prev + cur, 0);

      this.$set(
        this.spuForm,
        ESPUField.ORIGINAL_PRICE_CENT,
        (priceCent / 100).toFixed(2),
      );
    }
    const times = this.spuForm.effectiveTimes * 100;
    const comboTotalPrice = {
      originalPriceCent: Math.round(times * this.spuForm.originalPriceCent),
      vipPriceCent: Math.round(times * this.spuForm.vipPriceCent),
      newUserPriceCent:
        this.spuForm.hasNewUserPrice === true
          ? Math.round(times * this.spuForm.newUserPriceCent)
          : 0,
    };
    this.$set(this.spuForm, ESPUField.COMBO_TOTAL_PRICE, comboTotalPrice);
    this.spuEditor.setup(this.initSpuConfig(), this.spuForm, true);
  }

  mounted() {
    const { page } = this.$route.query;
    if (typeof page !== 'undefined') {
      this.pagination.current = +page;
    }
    this.handleSearch();
    this.getCategory();
  }

  async created() {
    const $asyncP = await this.permissionService.asyncPermissions([
      AuthEnum.标品视频管理,
    ]);
    $asyncP.subscribe((permissions: KeyObject<boolean>) => {
      if (permissions) {
        this.spuVideoPermmison = permissions;
      } else {
        this.spuVideoPermmison = {};
      }
    });
  }
}
